const vouchers = [
  {
    id: 1,
    title: 'Saloon Cars (Blue Booklet)',
    washes: ' 15 Exterior Washes',
    description: 'Save big with our special offer – originally priced at RO 24 for Saloons  now available at RO 15.75 for Saloons ',
    descriptionGrid: ' Ideal for sedans and compact cars.',
    oldPrice: 24,
    price: 15.75,
    offer:34.4,
    code: '00001',
    image_en: '/img/voucher/SaloonCars-english.png',
    image_om: '/img/voucher/SaloonCars-oman.png',
  },
  {
    id: 2,
    title: 'SUV/4x4 Voucher(Green Booklet)',
    washes: ' 15 Exterior Washes',
    description: 'Save big with our special offer – originally priced at RO 31.50 for SUVs/4x4s  now available at RO 18 for SUVs/4x4s ',
    descriptionGrid: 'Designed for larger vehicles like SUVs and 4x4s.',
    price:18.00,
    oldPrice: 31.5,
    offer:42.9,
    code: '00002',
    image_en: '/img/voucher/SUV&4x4-english.png',
    image_om: '/img/voucher/SUV&4x4-oman.png',
  },
];

const LoyaltyCards = [
    {
    id: 1,
    title: 'Loyalty Booklet',
    washes: 'Unlock massive savings on your car washes with our Prepaid Loyalty Coupon Booklet! For just one upfront purchase, get a booklet packed with 15 cleaning vouchers that let you enjoy premium washes at a fraction of the cost – saving you up to 40% overall.',
    description: 'Save big with our special offer – originally priced at RO 22.500 for Saloons  now available at RO 18 for Saloons ',
    descriptionGrid: ' Ideal for sedans and compact cars.',
    oldPrice: 24,
    price: 15,
    offer:37.5,
    code: '00001',
    image: '/img/voucher/generated-image 1.png',
    buttonText : "Learn More",
  },
  {
    id: 2,
    title: 'Splash & Save Loyalty Card',
    washes: 'Introducing our Splash & Save Loyalty Card – the simple, stamp-based way to score free washes and make every visit count',
    description: 'Save big with our special offer – originally priced at RO 22.500 for Saloons  now available at RO 18 for Saloons ',
    descriptionGrid: ' Ideal for sedans and compact cars.',
    oldPrice: 24,
    price: 15,
    offer:37.5,
    code: '00002',
    image: '/img/voucher/generated-image 1.png',
    buttonText : "Get Now!",
  },
]
export { vouchers , LoyaltyCards}; 